import Vue from "vue";
import Bus from "../Bus";
import Router from "vue-router";
import { setStore, getStore, setSessionStore } from "../utils/mUtils";
Vue.use(Router);
const routes = [
  {
    path: "/",
    redirect: "/welcome",
  },
  {
    path: "/welcome",
    name: "loginInfo",
    component: () => import("../views/login/welcome"),
    meta: {
      title: "大有阳光",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home"),
    meta: {
      title: "测测",
    },
    children: [],
  },
  {
    path: "/answer",
    name: "answer",
    component: () => import("../views/answer"),
    meta: {
      title: "开始测试",
      children: [],
    },
  },
  {
    path: "/result",
    name: "result",
    component: () => import("../views/result"),
    meta: {
      title: "测评结果",
      children: [],
    },
  },
  {
    path: "/share",
    name: "share",
    component: () => import("../views/share"),
    meta: {
      title: "大有阳光",
      children: [],
    },
  },
  {
    path: "/report",
    name: "report",
    component: () => import("../views/report"),
    meta: {
      title: "测评报告",
      children: [],
    },
  },
  {
    path: "/preview",
    name: "preview",
    component: () => import("../views/preview"),
    meta: {
      title: "测评报告-预览",
      children: [],
    },
  },
  {
    path: "/no2",
    name: "no2",
    component: () => import("../views/protocol/no2"),
    meta: {
      title: "",
      children: [],
    },
  },
  {
    path: "/no3",
    name: "no3",
    component: () => import("../views/protocol/no3"),
    meta: {
      title: "",
      children: [],
    },
  },
  {
    path: "/noAuth/401",
    name: "noAuth",
    component: () => import("../views/noAuth/index"),
    meta: {
      title: "无权访问",
      isleftarrow: true,
    },
  },
  {
    path: "/noAuth/notWx",
    name: "notWx",
    component: () => import("../views/noAuth/notWx"),
    meta: {
      title: "非微信环境",
      isleftarrow: true,
    },
  },
  {
    path: "/notFound/404",
    name: "notFound",
    component: () => import("../views/404/index"),
    meta: {
      title: "页面失联",
      isleftarrow: true,
    },
  },
  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/notFound/404",
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});
// console.log(routes);
const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_H5,
  routes,
});
// console.log('看看router', router);
router.beforeEach((to, from, next) => {
  if (
    getStore("token") ||
    to.name == "login" || // 测试用
    to.name == "loginInfo" || // 测试用
    to.name == "notFound" ||
    to.name == "notWx" ||
    to.name == "noAuth" ||
    to.name == "home" ||
    to.name == "answer" ||
    to.name == "result" ||
    to.name == "share" ||
    to.name == "report" ||
    to.name == "preview" ||
    to.name == "no2" ||
    to.name == "no3"
  ) {
    if (to.path === "/") {
      // 假设token存在,且没过期
      if (getStore("token")) {
        router.push({
          path: "/home",
        });
        next();
      }
      console.log(to);
      console.log(location.href);
      // 处理code,先分割#,在分割code=
      // if (location.href.search('code=') > -1 && location.href.search('&state=') > -1) {
      //   const originStr = location.origin + process.env.VUE_APP_H5 ? '/h5' : '' //项目在同域名下的h5文件夹中配置此项
      //   const code = location.href.split('#')[0].split(originStr)[1]
      //   location.href = originStr + '/#' + code
      //   console.log(code);
      //   // next({
      //   //   path: '/welcome',
      //   //   query: {code:code}
      //   // });
      // }
    }
    if (to.name == "HomeReport") {
      // 记录detail地址
      setSessionStore("REDIRECT_INFO", {
        path: "/home/report",
        query: to.query,
      });
    }
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  } else {
    next({
      path: "/noAuth/401",
    });
  }
});

export { router };
